import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { fade } from "svelte/transition";

var root = $.from_html(`<div class="body svelte-225iyfktup3yj"><!></div>`);
var root_1 = $.from_html(`<section class="group svelte-225iyfktup3yj"><button class="head svelte-225iyfktup3yj"><span> </span> <svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true"><path d="M2 3.5 L5 6.5 L8 3.5" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"></path></svg></button> <!></section>`);

export default function Section($$anchor, $$props) {
	$.push($$props, true);

	// svelte/transition animates via JS, out of reach of the CSS
	// reduced-motion override in app.css — gate the duration here.
	const fadeMs = matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : 120;

	var section = root_1();
	var button = $.child(section);
	var span = $.child(button);
	var text = $.child(span, true);

	$.reset(span);

	var svg = $.sibling(span, 2);
	let classes;

	$.reset(button);

	var node = $.sibling(button, 2);

	{
		var consequent = ($$anchor) => {
			var div = root();
			var node_1 = $.child(div);

			$.snippet(node_1, () => $$props.children);
			$.reset(div);
			$.transition(3, div, () => fade, () => ({ duration: fadeMs }));
			$.append($$anchor, div);
		};

		$.if(node, ($$render) => {
			if ($$props.open) $$render(consequent);
		});
	}

	$.reset(section);

	$.template_effect(() => {
		$.set_attribute(button, 'aria-expanded', $$props.open);
		$.set_text(text, $$props.label);
		classes = $.set_class(svg, 0, 'chev svelte-225iyfktup3yj', null, classes, { open: $$props.open });
	});

	$.delegated('click', button, function (...$$args) {
		$$props.ontoggle?.apply(this, $$args);
	});

	$.append($$anchor, section);
	$.pop();
}

$.delegate(['click']);
import "bun-svelte:Section.svelte-eqpcz9pw6t9b-style.css";